import { useEffect, useState } from 'react'
import { OrderDetails } from 'interfaces/order'
import { OrderDetailHttpRepository } from 'orders/infrastructure/repositories/OrderDetailHttpRepository'
import { GetOrderDetailUseCase } from 'orders/usecases/GetOrderDetailUseCase'
import { toOrderDetails } from 'orders/infrastructure/mappers/orderDetail.mapper'

interface UseOrderDetailResult {
    order: OrderDetails | null
    loading: boolean
    error: string | null
}

export function useOrderDetail(orderId: number): UseOrderDetailResult {
    const [order, setOrder] = useState<OrderDetails | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (!orderId || !isFinite(orderId)) return
        let cancelled = false

        const useCase = new GetOrderDetailUseCase(new OrderDetailHttpRepository())

        const fetchOrder = async () => {
            setLoading(true)
            setError(null)
            try {
                const entity = await useCase.execute(orderId)
                if (!cancelled) setOrder(toOrderDetails(entity))
            } catch {
                if (!cancelled) setError('No se pudo cargar el detalle de la orden.')
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        fetchOrder()
        return () => { cancelled = true }
    }, [orderId])

    return { order, loading, error }
}
